import { render, staticRenderFns } from "./folderTreeManager.vue?vue&type=template&id=fcf2bf6a"
import script from "./folderTreeManager.vue?vue&type=script&lang=js"
export * from "./folderTreeManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports